import { render } from "./WeekPicksAnalysis.vue?vue&type=template&id=534d8e35&scoped=true"
import script from "./WeekPicksAnalysis.vue?vue&type=script&lang=ts"
export * from "./WeekPicksAnalysis.vue?vue&type=script&lang=ts"

import "./WeekPicksAnalysis.vue?vue&type=style&index=0&id=534d8e35&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-534d8e35"

export default script